/**
 * J4 — Deep-Link auf eine Mail: `/emails?mailbox=…&message=…`.
 *
 * Historischer Bruch, hier geheilt: Der Delta-Dienst des Backends baute den
 * Link mit `msg=`, die Mail-Ansicht las `message=`. Die bestehende
 * „Neue E-Mail"-Mitteilung öffnete deshalb NIE die Mail. Beide Namen werden
 * jetzt akzeptiert (`message` gewinnt), und der Aufräum-Schritt löscht beide.
 */

/** Beide Parameternamen — der Aufräum-Block muss jeden davon entfernen. */
export const MAIL_DEEPLINK_PARAMS = ["mailbox", "message", "msg"] as const;

export type MailDeepLink = { mailbox: string; messageId: string };

/** Liest den Deep-Link; `null`, wenn Postfach oder Nachricht fehlen. */
export function leseMailDeepLink(params: {
    get(name: string): string | null;
}): MailDeepLink | null {
    const mailbox = (params.get("mailbox") ?? "").trim();
    const messageId = (params.get("message") ?? params.get("msg") ?? "").trim();
    if (!mailbox || !messageId) return null;
    return { mailbox, messageId };
}
